// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentationTab-module__font-s-10___m_1h_ {
  font-size: 10px !important;
}

.DocumentationTab-module__font-s-12___nJsrf {
  font-size: 12px !important;
}

.DocumentationTab-module__font-s-13___XD6EK {
  font-size: 13px !important;
}

.DocumentationTab-module__font-s-14___uA_Gy {
  font-size: 14px !important;
}

.DocumentationTab-module__font-s-15___cu1Zr {
  font-size: 15px !important;
}

.DocumentationTab-module__font-s-16___DHf2z {
  font-size: 16px !important;
}

.DocumentationTab-module__font-s-18___pYGJ4 {
  font-size: 18px !important;
}

.DocumentationTab-module__font-s-20___iolaX {
  font-size: 20px !important;
}

.DocumentationTab-module__font-s-22___V65Yk {
  font-size: 22px !important;
}

.DocumentationTab-module__font-s-28___ldvwg {
  font-size: 28px !important;
}

.DocumentationTab-module__font-w-400___wZiVU {
  font-weight: 400 !important;
}

.DocumentationTab-module__font-w-500___B8YXT {
  font-weight: 500 !important;
}

.DocumentationTab-module__font-w-600___wbJag {
  font-weight: 600 !important;
}

.DocumentationTab-module__font-w-700___zx_DL {
  font-weight: 700 !important;
}

.DocumentationTab-module__p-5___RsU9M {
  padding: 5px !important;
}

.DocumentationTab-module__p-12___e2MZ4 {
  padding: 12px !important;
}

.DocumentationTab-module__p-16___NOxvK {
  padding: 16px !important;
}

.DocumentationTab-module__p-30___Wdhvl {
  padding: 30px !important;
}

.DocumentationTab-module__p-b-0___ItMyL {
  padding-bottom: 0 !important;
}

.DocumentationTab-module__p-b-5___reiCH {
  padding-bottom: 5px !important;
}

.DocumentationTab-module__p-b-10___VFnlq {
  padding-bottom: 10px !important;
}

.DocumentationTab-module__p-b-12___mMi0v {
  padding-bottom: 12px !important;
}

.DocumentationTab-module__p-b-16___GovIb {
  padding-bottom: 16px !important;
}

.DocumentationTab-module__p-b-18___rYCnj {
  padding-bottom: 18px !important;
}

.DocumentationTab-module__p-b-20___QcSMh {
  padding-bottom: 20px !important;
}

.DocumentationTab-module__p-b-25___LI9cG {
  padding-bottom: 25px !important;
}

.DocumentationTab-module__p-b-30___cxB85 {
  padding-bottom: 30px !important;
}

.DocumentationTab-module__p-b-50___IKwy5 {
  padding-bottom: 50px !important;
}

.DocumentationTab-module__p-t-0___kcDzs {
  padding-top: 0 !important;
}

.DocumentationTab-module__p-t-12___AUDPQ {
  padding-top: 12px !important;
}

.DocumentationTab-module__p-t-16___B0hMe {
  padding-top: 16px !important;
}

.DocumentationTab-module__p-t-18___UyzVk {
  padding-top: 18px !important;
}

.DocumentationTab-module__p-t-20___G1hKz {
  padding-top: 20px !important;
}

.DocumentationTab-module__p-t-30___4hGMN {
  padding-top: 30px !important;
}

.DocumentationTab-module__p-t-40___vE0U0 {
  padding-top: 40px !important;
}

.DocumentationTab-module__p-t-50___CiV30 {
  padding-top: 50px !important;
}

.DocumentationTab-module__p-l-20___eXyq2 {
  padding-left: 20px !important;
}

.DocumentationTab-module__p-l-30___VGR6U {
  padding-left: 30px !important;
}

.DocumentationTab-module__p-l-40____HKqI {
  padding-left: 40px !important;
}

.DocumentationTab-module__p-r-16___xGk70 {
  padding-right: 16px !important;
}

.DocumentationTab-module__p-r-20___lTDzD {
  padding-right: 20px !important;
}

.DocumentationTab-module__p-r-30___YGIQ6 {
  padding-right: 30px !important;
}

.DocumentationTab-module__p-r-50___N6225 {
  padding-right: 50px !important;
}

.DocumentationTab-module__p-r-60___WJBIK {
  padding-right: 60px !important;
}

.DocumentationTab-module__m-b-1___OMC2_ {
  margin-bottom: 1px !important;
}

.DocumentationTab-module__m-b-2___ixfqz {
  margin-bottom: 2px !important;
}

.DocumentationTab-module__m-b-6___yYKaz {
  margin-bottom: 6px !important;
}

.DocumentationTab-module__m-b-8___asHvH {
  margin-bottom: 8px !important;
}

.DocumentationTab-module__m-b-10___TSOyl {
  margin-bottom: 10px !important;
}

.DocumentationTab-module__m-b-14___nljsZ {
  margin-bottom: 14px !important;
}

.DocumentationTab-module__m-b-16___nC8Rm {
  margin-bottom: 16px !important;
}

.DocumentationTab-module__m-b-20___N164u {
  margin-bottom: 20px !important;
}

.DocumentationTab-module__m-b-22___RMrZl {
  margin-bottom: 22px !important;
}

.DocumentationTab-module__m-b-24___nS9J9 {
  margin-bottom: 24px !important;
}

.DocumentationTab-module__m-b-30___j7MzP {
  margin-bottom: 30px !important;
}

.DocumentationTab-module__m-b-32___xmo_p {
  margin-bottom: 32px !important;
}

.DocumentationTab-module__m-b-40___j8Vn5 {
  margin-bottom: 40px !important;
}

.DocumentationTab-module__m-t-2___tMoaS {
  margin-top: 2px !important;
}

.DocumentationTab-module__m-t-3___jWwB2 {
  margin-top: 3px !important;
}

.DocumentationTab-module__m-t-4___v7Cg3 {
  margin-top: 4px !important;
}

.DocumentationTab-module__m-t-5___nFSLO {
  margin-top: 5px !important;
}

.DocumentationTab-module__m-t-8___IcSzG {
  margin-top: 8px !important;
}

.DocumentationTab-module__m-t-10___b8Oe1 {
  margin-top: 10px !important;
}

.DocumentationTab-module__m-t-15___TBffO {
  margin-top: 15px !important;
}

.DocumentationTab-module__m-t-16___n16_J {
  margin-top: 16px !important;
}

.DocumentationTab-module__m-t-20___eVJu0 {
  margin-top: 20px !important;
}

.DocumentationTab-module__m-t-22___uzs3R {
  margin-top: 22px !important;
}

.DocumentationTab-module__m-t-30___mAYEG {
  margin-top: 30px !important;
}

.DocumentationTab-module__m-t-32___tWFNv {
  margin-top: 32px !important;
}

.DocumentationTab-module__m-l-auto___hFil0 {
  margin-left: auto !important;
}

.DocumentationTab-module__m-l-4___DT3tY {
  margin-left: 4px !important;
}

.DocumentationTab-module__m-l-5___Xun6e {
  margin-left: 5px !important;
}

.DocumentationTab-module__m-l-6___v5FsW {
  margin-left: 6px !important;
}

.DocumentationTab-module__m-l-8___Wj3l0 {
  margin-left: 8px !important;
}

.DocumentationTab-module__m-l-10___xMwS3 {
  margin-left: 10px !important;
}

.DocumentationTab-module__m-l-16___eLk8W {
  margin-left: 16px !important;
}

.DocumentationTab-module__m-l-20___XFsx1 {
  margin-left: 20px !important;
}

.DocumentationTab-module__m-l-24___ILHZv {
  margin-left: 24px !important;
}

.DocumentationTab-module__m-l-30___VD4SO {
  margin-left: 30px !important;
}

.DocumentationTab-module__m-l-35____iuMD {
  margin-left: 35px !important;
}

.DocumentationTab-module__m-l-40___hn72C {
  margin-left: 40px !important;
}

.DocumentationTab-module__m-r-8___Xq216 {
  margin-right: 8px !important;
}

.DocumentationTab-module__m-r-10___sC7xi {
  margin-right: 10px !important;
}

.DocumentationTab-module__m-r-16___SRmDr {
  margin-right: 16px !important;
}

.DocumentationTab-module__m-r-20___CE5zY {
  margin-right: 20px !important;
}

.DocumentationTab-module__m-r-24___ykRyI {
  margin-right: 24px !important;
}

.DocumentationTab-module__m-r-30___C34k2 {
  margin-right: 30px !important;
}

.DocumentationTab-module__m-r-40___K8R8e {
  margin-right: 40px !important;
}

.DocumentationTab-module__border-r-3___lLcz6 {
  border-radius: 3px !important;
}

.DocumentationTab-module__border-r-4___tCo_M {
  border-radius: 4px !important;
}

.DocumentationTab-module__border-r-6___OEDeh {
  border-radius: 6px !important;
}

.DocumentationTab-module__border-r-10___BT_Oc {
  border-radius: 10px !important;
}

.DocumentationTab-module__border-r-12___bBFvq {
  border-radius: 12px !important;
}

.DocumentationTab-module__border-r-16___AnhjQ {
  border-radius: 16px !important;
}

.DocumentationTab-module__border-r-50___bxy78 {
  border-radius: 50% !important;
}

.DocumentationTab-module__primary-border___bYM3F {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationTab-module__primary-border-b___RljgP {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationTab-module__primary-border-t___zcvBi {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationTab-module__primary-border-l___kVJe6 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationTab-module__primary-border-r___mjdWQ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DocumentationTab-module__secondary-border____kC6V {
  border: 1px solid #637768;
}

.DocumentationTab-module__secondary-border-b___ptNik {
  border-bottom: 1px solid #637768;
}

.DocumentationTab-module__secondary-border-t___jtreU {
  border-top: 1px solid #637768;
}

.DocumentationTab-module__secondary-border-l___ELzWF {
  border-left: 1px solid #637768;
}

.DocumentationTab-module__secondary-border-r___alz8v {
  border-right: 1px solid #637768;
}

.DocumentationTab-module__gap-0___lKJWW {
  gap: 0 !important;
}

.DocumentationTab-module__gap-2___m8Hf1 {
  gap: 2px !important;
}

.DocumentationTab-module__gap-4___uXyDP {
  gap: 4px !important;
}

.DocumentationTab-module__gap-5___TP02Q {
  gap: 5px !important;
}

.DocumentationTab-module__gap-6___xJJkr {
  gap: 6px !important;
}

.DocumentationTab-module__gap-8___U5ifI {
  gap: 8px !important;
}

.DocumentationTab-module__gap-10____s9QB {
  gap: 10px !important;
}

.DocumentationTab-module__gap-12___Mt32n {
  gap: 12px !important;
}

.DocumentationTab-module__gap-14___SbbGS {
  gap: 14px !important;
}

.DocumentationTab-module__gap-16___K4gLS {
  gap: 16px !important;
}

.DocumentationTab-module__gap-18___djEEX {
  gap: 18px !important;
}

.DocumentationTab-module__gap-20___nG9jn {
  gap: 20px !important;
}

.DocumentationTab-module__gap-24___Xb94Y {
  gap: 24px !important;
}

.DocumentationTab-module__gap-26___hoiAF {
  gap: 26px !important;
}

.DocumentationTab-module__gap-30___uTRrM {
  gap: 30px !important;
}

.DocumentationTab-module__gap-32___Jt_Jk {
  gap: 32px !important;
}

.DocumentationTab-module__gap-40___pzL2M {
  gap: 40px !important;
}

.DocumentationTab-module__gap-50___Co0Ja {
  gap: 50px !important;
}

.DocumentationTab-module__flex-1___NtAhM {
  flex: 1;
}

.DocumentationTab-module__flex-none___q1L1J {
  flex: none !important;
}

.DocumentationTab-module__flex-column___OJAhi {
  display: flex;
  flex-direction: column !important;
}

.DocumentationTab-module__flex-row___wLCfP {
  display: flex;
  flex-direction: row !important;
}

.DocumentationTab-module__vertically-centered___nJORE {
  display: flex;
  align-items: center !important;
}

.DocumentationTab-module__horizontally-centered___fxuTH {
  display: flex;
  justify-content: center !important;
}

.DocumentationTab-module__horizontally-end___WBwbt {
  display: flex;
  justify-content: end !important;
}

.DocumentationTab-module__vertically-start___x3DqY {
  display: flex;
  align-items: start !important;
}

.DocumentationTab-module__space-between___uQeLE {
  display: flex;
  justify-content: space-between !important;
}

.DocumentationTab-module__flex-wrap___QPaHz {
  flex-wrap: wrap !important;
}

.DocumentationTab-module__height-100___UsLgY {
  height: 100%;
}

.DocumentationTab-module__width-50___Xc2hw {
  width: 50% !important;
}

.DocumentationTab-module__width-100___Qyl0P {
  width: 100%;
}

.DocumentationTab-module__cursor-pointer___h3jjz {
  cursor: pointer;
}

.DocumentationTab-module__cursor-not-allowed___MwJEq {
  cursor: not-allowed !important;
}

.DocumentationTab-module__absolute-centered___ampsn {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DocumentationTab-module__absolute___jmkSo {
  position: absolute;
}

.DocumentationTab-module__relative___h8age {
  position: relative;
}

.DocumentationTab-module__fixed___xRIWP {
  position: fixed;
}

.DocumentationTab-module__visible___rk46T {
  opacity: 1;
}

.DocumentationTab-module__invisible___Fybz3 {
  opacity: 0;
}

.DocumentationTab-module__col-90___KdcGS {
  width: 90% !important;
}

.DocumentationTab-module__col-auto___ulqxe {
  width: auto !important;
}

.DocumentationTab-module__medical-tabs___Qrdar {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DocumentationTab-module__medical-table-new___aiPKF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationTab-module__medical-table-new___aiPKF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationTab-module__medical-table-new___aiPKF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationTab-module__medical-table-new___aiPKF::-webkit-scrollbar-track {
  display: none;
}
.DocumentationTab-module__medical-table-new___aiPKF.DocumentationTab-module__no-pagination___avNO2 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationTab-module__medical-table-new___aiPKF.DocumentationTab-module__no-pagination___avNO2:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationTab-module__medical-table-new___aiPKF.DocumentationTab-module__no-pagination___avNO2::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationTab-module__medical-table-new___aiPKF.DocumentationTab-module__no-pagination___avNO2::-webkit-scrollbar-track {
  display: none;
}

.DocumentationTab-module__medical-table-empty___nrhXo {
  padding: 14px 40px !important;
}

.DocumentationTab-module__icon-btn___TkMEP {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DocumentationTab-module__search-icon___fBiix {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DocumentationTab-module__disable-select___vUz1d {
  user-select: none;
}

.DocumentationTab-module__break-word___zA6q0 {
  word-break: break-word;
}

.DocumentationTab-module__popup-clear-btn___miqQV {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DocumentationTab-module__scroll-m-b-20___NWmt7 {
  scroll-margin-bottom: 20px;
}

.DocumentationTab-module__container___aI0gr {
  flex: 1;
  display: flex;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__sidebar___RyvDz {
  cursor: pointer;
  width: 290px;
  height: calc(100vh - 53px - var(--patient-details-header) - var(--patient-details-footer) - 140px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__sidebar___RyvDz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__sidebar___RyvDz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__sidebar___RyvDz::-webkit-scrollbar-track {
  display: none;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__content___kPrOM {
  flex: 1;
  height: calc(100vh - 53px - var(--patient-details-header) - var(--patient-details-footer) - 140px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__content___kPrOM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__content___kPrOM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DocumentationTab-module__container___aI0gr .DocumentationTab-module__content___kPrOM::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DocumentationFragment/tabs/DocumentationTab/DocumentationTab.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,aAAA;AA8pBF;AA5pBE;EACE,eAAA;EACA,YAAA;ECEF,kGAAA;EACA,kBAAA;EACA,kBAAA;AD6pBF;AC3pBE;EACE,oCAAA;EACA,mBAAA;AD6pBJ;AC1pBE;EACE,UAAA;EACA,6BAAA;AD4pBJ;ACzpBE;EACE,aAAA;AD2pBJ;AAnqBE;EACE,OAAA;ECRF,kGDUI;ECTJ,kBAAA;EACA,kBAAA;AD8qBF;AC5qBE;EACE,oCAAA;EACA,mBAAA;AD8qBJ;AC3qBE;EACE,UAAA;EACA,6BAAA;AD6qBJ;AC1qBE;EACE,aAAA;AD4qBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  display: flex;\n\n  .sidebar {\n    cursor: pointer;\n    width: 290px;\n    @include verticalScroll(\n      calc(\n        100vh - #{$top-navigation} - var(--patient-details-header) - var(--patient-details-footer) -\n          140px\n      )\n    );\n  }\n\n  .content {\n    flex: 1;\n    @include verticalScroll(\n      calc(\n        100vh - #{$top-navigation} - var(--patient-details-header) - var(--patient-details-footer) -\n          140px\n      )\n    );\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DocumentationTab-module__font-s-10___m_1h_`,
	"fontS12": `DocumentationTab-module__font-s-12___nJsrf`,
	"fontS13": `DocumentationTab-module__font-s-13___XD6EK`,
	"fontS14": `DocumentationTab-module__font-s-14___uA_Gy`,
	"fontS15": `DocumentationTab-module__font-s-15___cu1Zr`,
	"fontS16": `DocumentationTab-module__font-s-16___DHf2z`,
	"fontS18": `DocumentationTab-module__font-s-18___pYGJ4`,
	"fontS20": `DocumentationTab-module__font-s-20___iolaX`,
	"fontS22": `DocumentationTab-module__font-s-22___V65Yk`,
	"fontS28": `DocumentationTab-module__font-s-28___ldvwg`,
	"fontW400": `DocumentationTab-module__font-w-400___wZiVU`,
	"fontW500": `DocumentationTab-module__font-w-500___B8YXT`,
	"fontW600": `DocumentationTab-module__font-w-600___wbJag`,
	"fontW700": `DocumentationTab-module__font-w-700___zx_DL`,
	"p5": `DocumentationTab-module__p-5___RsU9M`,
	"p12": `DocumentationTab-module__p-12___e2MZ4`,
	"p16": `DocumentationTab-module__p-16___NOxvK`,
	"p30": `DocumentationTab-module__p-30___Wdhvl`,
	"pB0": `DocumentationTab-module__p-b-0___ItMyL`,
	"pB5": `DocumentationTab-module__p-b-5___reiCH`,
	"pB10": `DocumentationTab-module__p-b-10___VFnlq`,
	"pB12": `DocumentationTab-module__p-b-12___mMi0v`,
	"pB16": `DocumentationTab-module__p-b-16___GovIb`,
	"pB18": `DocumentationTab-module__p-b-18___rYCnj`,
	"pB20": `DocumentationTab-module__p-b-20___QcSMh`,
	"pB25": `DocumentationTab-module__p-b-25___LI9cG`,
	"pB30": `DocumentationTab-module__p-b-30___cxB85`,
	"pB50": `DocumentationTab-module__p-b-50___IKwy5`,
	"pT0": `DocumentationTab-module__p-t-0___kcDzs`,
	"pT12": `DocumentationTab-module__p-t-12___AUDPQ`,
	"pT16": `DocumentationTab-module__p-t-16___B0hMe`,
	"pT18": `DocumentationTab-module__p-t-18___UyzVk`,
	"pT20": `DocumentationTab-module__p-t-20___G1hKz`,
	"pT30": `DocumentationTab-module__p-t-30___4hGMN`,
	"pT40": `DocumentationTab-module__p-t-40___vE0U0`,
	"pT50": `DocumentationTab-module__p-t-50___CiV30`,
	"pL20": `DocumentationTab-module__p-l-20___eXyq2`,
	"pL30": `DocumentationTab-module__p-l-30___VGR6U`,
	"pL40": `DocumentationTab-module__p-l-40____HKqI`,
	"pR16": `DocumentationTab-module__p-r-16___xGk70`,
	"pR20": `DocumentationTab-module__p-r-20___lTDzD`,
	"pR30": `DocumentationTab-module__p-r-30___YGIQ6`,
	"pR50": `DocumentationTab-module__p-r-50___N6225`,
	"pR60": `DocumentationTab-module__p-r-60___WJBIK`,
	"mB1": `DocumentationTab-module__m-b-1___OMC2_`,
	"mB2": `DocumentationTab-module__m-b-2___ixfqz`,
	"mB6": `DocumentationTab-module__m-b-6___yYKaz`,
	"mB8": `DocumentationTab-module__m-b-8___asHvH`,
	"mB10": `DocumentationTab-module__m-b-10___TSOyl`,
	"mB14": `DocumentationTab-module__m-b-14___nljsZ`,
	"mB16": `DocumentationTab-module__m-b-16___nC8Rm`,
	"mB20": `DocumentationTab-module__m-b-20___N164u`,
	"mB22": `DocumentationTab-module__m-b-22___RMrZl`,
	"mB24": `DocumentationTab-module__m-b-24___nS9J9`,
	"mB30": `DocumentationTab-module__m-b-30___j7MzP`,
	"mB32": `DocumentationTab-module__m-b-32___xmo_p`,
	"mB40": `DocumentationTab-module__m-b-40___j8Vn5`,
	"mT2": `DocumentationTab-module__m-t-2___tMoaS`,
	"mT3": `DocumentationTab-module__m-t-3___jWwB2`,
	"mT4": `DocumentationTab-module__m-t-4___v7Cg3`,
	"mT5": `DocumentationTab-module__m-t-5___nFSLO`,
	"mT8": `DocumentationTab-module__m-t-8___IcSzG`,
	"mT10": `DocumentationTab-module__m-t-10___b8Oe1`,
	"mT15": `DocumentationTab-module__m-t-15___TBffO`,
	"mT16": `DocumentationTab-module__m-t-16___n16_J`,
	"mT20": `DocumentationTab-module__m-t-20___eVJu0`,
	"mT22": `DocumentationTab-module__m-t-22___uzs3R`,
	"mT30": `DocumentationTab-module__m-t-30___mAYEG`,
	"mT32": `DocumentationTab-module__m-t-32___tWFNv`,
	"mLAuto": `DocumentationTab-module__m-l-auto___hFil0`,
	"mL4": `DocumentationTab-module__m-l-4___DT3tY`,
	"mL5": `DocumentationTab-module__m-l-5___Xun6e`,
	"mL6": `DocumentationTab-module__m-l-6___v5FsW`,
	"mL8": `DocumentationTab-module__m-l-8___Wj3l0`,
	"mL10": `DocumentationTab-module__m-l-10___xMwS3`,
	"mL16": `DocumentationTab-module__m-l-16___eLk8W`,
	"mL20": `DocumentationTab-module__m-l-20___XFsx1`,
	"mL24": `DocumentationTab-module__m-l-24___ILHZv`,
	"mL30": `DocumentationTab-module__m-l-30___VD4SO`,
	"mL35": `DocumentationTab-module__m-l-35____iuMD`,
	"mL40": `DocumentationTab-module__m-l-40___hn72C`,
	"mR8": `DocumentationTab-module__m-r-8___Xq216`,
	"mR10": `DocumentationTab-module__m-r-10___sC7xi`,
	"mR16": `DocumentationTab-module__m-r-16___SRmDr`,
	"mR20": `DocumentationTab-module__m-r-20___CE5zY`,
	"mR24": `DocumentationTab-module__m-r-24___ykRyI`,
	"mR30": `DocumentationTab-module__m-r-30___C34k2`,
	"mR40": `DocumentationTab-module__m-r-40___K8R8e`,
	"borderR3": `DocumentationTab-module__border-r-3___lLcz6`,
	"borderR4": `DocumentationTab-module__border-r-4___tCo_M`,
	"borderR6": `DocumentationTab-module__border-r-6___OEDeh`,
	"borderR10": `DocumentationTab-module__border-r-10___BT_Oc`,
	"borderR12": `DocumentationTab-module__border-r-12___bBFvq`,
	"borderR16": `DocumentationTab-module__border-r-16___AnhjQ`,
	"borderR50": `DocumentationTab-module__border-r-50___bxy78`,
	"primaryBorder": `DocumentationTab-module__primary-border___bYM3F`,
	"primaryBorderB": `DocumentationTab-module__primary-border-b___RljgP`,
	"primaryBorderT": `DocumentationTab-module__primary-border-t___zcvBi`,
	"primaryBorderL": `DocumentationTab-module__primary-border-l___kVJe6`,
	"primaryBorderR": `DocumentationTab-module__primary-border-r___mjdWQ`,
	"secondaryBorder": `DocumentationTab-module__secondary-border____kC6V`,
	"secondaryBorderB": `DocumentationTab-module__secondary-border-b___ptNik`,
	"secondaryBorderT": `DocumentationTab-module__secondary-border-t___jtreU`,
	"secondaryBorderL": `DocumentationTab-module__secondary-border-l___ELzWF`,
	"secondaryBorderR": `DocumentationTab-module__secondary-border-r___alz8v`,
	"gap0": `DocumentationTab-module__gap-0___lKJWW`,
	"gap2": `DocumentationTab-module__gap-2___m8Hf1`,
	"gap4": `DocumentationTab-module__gap-4___uXyDP`,
	"gap5": `DocumentationTab-module__gap-5___TP02Q`,
	"gap6": `DocumentationTab-module__gap-6___xJJkr`,
	"gap8": `DocumentationTab-module__gap-8___U5ifI`,
	"gap10": `DocumentationTab-module__gap-10____s9QB`,
	"gap12": `DocumentationTab-module__gap-12___Mt32n`,
	"gap14": `DocumentationTab-module__gap-14___SbbGS`,
	"gap16": `DocumentationTab-module__gap-16___K4gLS`,
	"gap18": `DocumentationTab-module__gap-18___djEEX`,
	"gap20": `DocumentationTab-module__gap-20___nG9jn`,
	"gap24": `DocumentationTab-module__gap-24___Xb94Y`,
	"gap26": `DocumentationTab-module__gap-26___hoiAF`,
	"gap30": `DocumentationTab-module__gap-30___uTRrM`,
	"gap32": `DocumentationTab-module__gap-32___Jt_Jk`,
	"gap40": `DocumentationTab-module__gap-40___pzL2M`,
	"gap50": `DocumentationTab-module__gap-50___Co0Ja`,
	"flex1": `DocumentationTab-module__flex-1___NtAhM`,
	"flexNone": `DocumentationTab-module__flex-none___q1L1J`,
	"flexColumn": `DocumentationTab-module__flex-column___OJAhi`,
	"flexRow": `DocumentationTab-module__flex-row___wLCfP`,
	"verticallyCentered": `DocumentationTab-module__vertically-centered___nJORE`,
	"horizontallyCentered": `DocumentationTab-module__horizontally-centered___fxuTH`,
	"horizontallyEnd": `DocumentationTab-module__horizontally-end___WBwbt`,
	"verticallyStart": `DocumentationTab-module__vertically-start___x3DqY`,
	"spaceBetween": `DocumentationTab-module__space-between___uQeLE`,
	"flexWrap": `DocumentationTab-module__flex-wrap___QPaHz`,
	"height100": `DocumentationTab-module__height-100___UsLgY`,
	"width50": `DocumentationTab-module__width-50___Xc2hw`,
	"width100": `DocumentationTab-module__width-100___Qyl0P`,
	"cursorPointer": `DocumentationTab-module__cursor-pointer___h3jjz`,
	"cursorNotAllowed": `DocumentationTab-module__cursor-not-allowed___MwJEq`,
	"absoluteCentered": `DocumentationTab-module__absolute-centered___ampsn`,
	"absolute": `DocumentationTab-module__absolute___jmkSo`,
	"relative": `DocumentationTab-module__relative___h8age`,
	"fixed": `DocumentationTab-module__fixed___xRIWP`,
	"visible": `DocumentationTab-module__visible___rk46T`,
	"invisible": `DocumentationTab-module__invisible___Fybz3`,
	"col90": `DocumentationTab-module__col-90___KdcGS`,
	"colAuto": `DocumentationTab-module__col-auto___ulqxe`,
	"medicalTabs": `DocumentationTab-module__medical-tabs___Qrdar`,
	"medicalTableNew": `DocumentationTab-module__medical-table-new___aiPKF`,
	"noPagination": `DocumentationTab-module__no-pagination___avNO2`,
	"medicalTableEmpty": `DocumentationTab-module__medical-table-empty___nrhXo`,
	"iconBtn": `DocumentationTab-module__icon-btn___TkMEP`,
	"searchIcon": `DocumentationTab-module__search-icon___fBiix`,
	"disableSelect": `DocumentationTab-module__disable-select___vUz1d`,
	"breakWord": `DocumentationTab-module__break-word___zA6q0`,
	"popupClearBtn": `DocumentationTab-module__popup-clear-btn___miqQV`,
	"scrollMB20": `DocumentationTab-module__scroll-m-b-20___NWmt7`,
	"container": `DocumentationTab-module__container___aI0gr`,
	"sidebar": `DocumentationTab-module__sidebar___RyvDz`,
	"content": `DocumentationTab-module__content___kPrOM`
};
module.exports = ___CSS_LOADER_EXPORT___;
